import React from "react";
import { Stack } from "@mui/system";
import {
  Box,
  Button,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import * as Yup from "yup";
import { Formik } from "formik";

const useStyles = makeStyles(() => ({
  styledTextfield: {
    "& .MuiInputBase-root": {
      borderRadius: "12px",
    },
  },
}));

const SignupForm = () => {
  const classes = useStyles();

  const INI_DATA = {
    name: "",
    email: "",
    password: "",
    c_password: "",
  };

  const SCHEMA = {
    name: Yup.string()
      .required("Field is required")
      .matches(/^[aA-zZ\s]+$/, "Numbers and special character not allowed"),
    email: Yup.string().required("Field is required").email(),
    password: Yup.string()
      .required("Field is required")
      .min(8, "Password is too short - must be 8 characters minimum.")
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/,
        "Must contain an Uppercase, Lowercase and a Number "
      ),
  };

  return (
    <Stack justifyContent="center" alignItems="center" spacing={5}>
      <Stack alignItems="center" spacing={3}>
        <Typography variant="h1" fontWeight={700}>
          Welcome to EventView360!
        </Typography>
        <Typography variant="h4" fontWeight={500}>
          Getting started is easy
        </Typography>
      </Stack>
      <Formik
        initialValues={INI_DATA}
        validationSchema={Yup.object().shape(SCHEMA)}
        onSubmit={(values) => console.log(values)}
        render={({
          handleChange,
          values,
          touched,
          errors,
          handleSubmit,
        }: any) => (
          <Stack width="50%">
            <form onSubmit={handleSubmit}>
              <Stack spacing={0.5}>
                <Typography>Full Name</Typography>
                <TextField
                  className={classes.styledTextfield}
                  placeholder="John Doe"
                  fullWidth
                  style={{ border: 0, padding: 0 }}
                  id="name"
                  helperText={
                    touched.name && errors !== null ? errors.name : ""
                  }
                  error={touched.name && errors !== null && errors.name}
                  onChange={handleChange}
                  value={values.name}
                  variant="outlined"
                />
              </Stack>
              <Stack spacing={0.5} mt={1.5}>
                <Typography>Email</Typography>
                <TextField
                  className={classes.styledTextfield}
                  placeholder="johndoe@gmail.com"
                  fullWidth
                  id="email"
                  style={{ border: 0, padding: 0 }}
                  helperText={
                    touched.email && errors !== null ? errors.email : ""
                  }
                  error={touched.email && errors !== null && errors.email}
                  onChange={handleChange}
                  value={values.email}
                />
              </Stack>
              <Stack spacing={0.5} position="relative" mt={1.5}>
                <Typography>Password</Typography>
                <TextField
                  className={classes.styledTextfield}
                  type="password"
                  placeholder="*********"
                  fullWidth
                  id="password"
                  style={{ border: 0, padding: 0 }}
                  helperText={
                    touched.password && errors !== null ? errors.password : ""
                  }
                  error={touched.password && errors !== null && errors.password}
                  onChange={handleChange}
                  value={values.password}
                  variant="outlined"
                />
              </Stack>
              <Stack spacing={0.5} position="relative" mt={1.5}>
                <Typography> Confirm Password</Typography>
                <TextField
                  className={classes.styledTextfield}
                  type="password"
                  placeholder="*********"
                  fullWidth
                  id="c_password"
                  style={{ border: 0, padding: 0 }}
                  helperText={
                    touched.c_password && errors !== null
                      ? errors.c_password
                      : ""
                  }
                  error={
                    touched.c_password && errors !== null && errors.c_password
                  }
                  onChange={handleChange}
                  value={values.c_password}
                  variant="outlined"
                />
              </Stack>
              <Stack spacing={0.5} position="relative" mt={1.5}>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: "primary",
                        border: "1px solid primary",
                        "&.Mui-checked": {
                          color: "primary",
                        },
                      }}
                    />
                  }
                  label=" I agree to Privacy Policy"
                />
              </Stack>
              <Box mt={2}>
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  fullWidth
                >
                  Create Account
                </Button>
              </Box>
              <Box mt={2} textAlign="center">
                Already have an account? Login
              </Box>
            </form>
          </Stack>
        )}
      />
    </Stack>
  );
};
export default SignupForm;
